var _path, _rect, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlac(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6V24H4V0H16L22 6ZM5 23H21V7H15V1H5V23ZM16 6H20.5L16 1.5V6Z",
    fill: "#040404"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 13,
    width: 24,
    height: 9,
    rx: 1,
    fill: "#C600C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1826 20H17.1074L16.5576 18.8428H14.6074L14.0596 20H13L15.0977 15H16.1094L18.1826 20ZM14.9521 18.1143H16.2109L15.6074 16L14.9521 18.1143Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 15C22.7095 15 23.7186 15.8589 23.9502 17H22.9131C22.707 16.4177 22.1529 16 21.5 16C20.6716 16 20 16.6716 20 17.5C20 18.3284 20.6716 19 21.5 19C22.1529 19 22.707 18.5823 22.9131 18H23.9502C23.7186 19.1411 22.7095 20 21.5 20C20.1193 20 19 18.8807 19 17.5C19 16.1193 20.1193 15 21.5 15Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.9961H12V19.9873L8.0127 19.9961L8 15.0039L9 15.002V18.9961Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.0088V16H4V17H6V18H4V19.9941L3 19.9922L3.0127 15L7 15.0088Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlac);
export default __webpack_public_path__ + "static/media/flac.47e3692aa4f42edec7a02c4a13b346f0.svg";
export { ForwardRef as ReactComponent };